<template>
  <section class="summary-books">
    <div class="summary-books__header">
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.82125 3.72359C9.85132 3.51792 10.1486 3.51792 10.1787 3.72359C10.6392 6.881 13.1189 9.36077 16.2763 9.82125C16.482 9.85132 16.482 10.1486 16.2763 10.1787C13.1189 10.6392 10.6392 13.1189 10.1787 16.2763C10.1486 16.482 9.85132 16.482 9.82125 16.2763C9.36077 13.1189 6.881 10.6392 3.72359 10.1787C3.51792 10.1486 3.51792 9.85132 3.72359 9.82125C6.881 9.36077 9.36077 6.881 9.82125 3.72359Z"
          fill="#3876F0"
          fill-opacity="0.5"
        />
      </svg>

      <div>
        <p class="summary-books__label">What caught your interest.</p>
        <p class="summary-books__desc">
          We’ll add these books to your Want to Read list.
        </p>
      </div>
    </div>
    <ul class="summary-books__covers">
      <li v-for="slug in slugs" :key="slug" class="summary-books__book">
        <img
          :src="coverUrl(slug)"
          alt=""
          width="158"
          height="211"
          class="summary-books__cover"
        />
      </li>
    </ul>
  </section>
</template>

<script setup lang="ts">
defineProps<{
  slugs: string[]
  coverUrl: (slug: string) => string
}>()
</script>

<style lang="scss" scoped>
.summary-books {
  background: $c-white;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  padding: 20px 16px;
  padding-bottom: 20px;

  &__header {
    display: flex;
    gap: 12px;
    margin-bottom: 12px;
  }

  &__label {
    color: $c-black-3;
    font-size: 16px;
    line-height: 130%;
    margin-bottom: 4px;
    font-style: italic;
  }

  &__desc {
    color: $c-black-15;
    font-size: 16px;
    line-height: 130%;
  }

  &__covers {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    list-style: none;
    margin: 8px 0 0;
    padding: 0;
  }

  &__book {
    position: relative;
    flex-shrink: 0;
    margin-top: -6px;
    margin-left: -10px;
    border-radius: 8px;
    border: 2px solid $c-white;
    filter: drop-shadow(-4px 3px 10px rgba(0, 0, 0, 0.12))
      drop-shadow(0 2px 6px rgba(0, 0, 0, 0.08));

    &:first-child {
      margin-left: 0;
    }
  }

  &__cover {
    display: block;
    width: auto;
    height: 88px;
    max-width: none;
    border-radius: 6px;
  }
}
</style>
